<template>
  <div :class="{ 'edit-bg': true, 'default-edit_bg': isDefault }">
    <el-scrollbar>
      <div class="bgTitle">
        <el-radio-group @change="buttonHandler" :value="type">
          <el-radio class="title-radio" label="0">官方模板</el-radio>
          <el-radio class="title-radio" label="1">私有模板<i class="vip-normal">VIP</i></el-radio>
        </el-radio-group>
      </div>
      <div class="uploadBg" v-show="type == 1">
        <div class="customBg" v-if="!isDefault">
          <label class="uploadBgButton" for="uploadBgButton">上传背景模板</label>
          <input type="file" id="uploadBgButton" ref="upbg" value="imgFile" accept="image/png, image/jpeg" @change="uploadImg($event)" style="display:none" />
        </div>
        <div class="thumbnail upload-tip">
          <div class="customBg" v-if="isDefault">
            <label class="uploadBgButton" for="uploadBgButton">上传背景模板</label>
            <input type="file" id="uploadBgButton" ref="upbg" value="imgFile" accept="image/png, image/jpeg" @change="uploadImg($event)" style="display:none" />
          </div>
          <div>
            <p>建议尺寸2048*1536</p>
            <p>显示效果最佳</p>
          </div>
        </div>
        <div class="bg-img" v-for="(item, index) in privateSrc" :key="index">
          <div class="selected-icon" v-if="selectIndex == index">√</div>
          <img :class="{ selected: selectIndex == index }" :src="item.path" @click="changeBg(item.path, index)" />
          <div class="deal-btn-wrapper">
            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
              <img class="icon-style" src="@imgs/delete-icon.png" @click="delBg(item)" />
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="public-bg" v-show="type == 0">
        <div class="bg-img" v-for="(item, index) in srcArr" :key="index">
          <div class="selected-icon" v-if="selectIndex == index">√</div>
          <img :class="{ border: item.border, selected: selectIndex == index }" :src="item.src" @click="changeBg(item.src, index)" />
        </div>
      </div>
    </el-scrollbar>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions" :appendToBody="true"></tip-dialog>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" :appendToBody="true" @clickCancel="deleteCancel" @clickConfirm="deleteConfrim"></TipDialog>
  </div>
</template>
<script>
import TipDialog from '@components/common/TipDialog.vue'
import compareVipRight from '@components/common/compareVipRight.js'
import editApi from '@api/setBook'
export default {
  name: 'editBg',
  data() {
    return {
      privateSrc: [],
      selectIndex: null,
      cropImgUrl: '',
      uploadBg: false,
      type: '0',
      delId: '',
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确认删除？'
      }
    }
  },
  props: {
    isDefault: {
      type: Boolean,
      default: false
    },
    bgType: {
      type: String,
      default: 'background'
    }
  },
  mixins: [compareVipRight],
  computed: {
    lastBg() {
      return this.$store.state.config.bookObj.lastBg
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    currentBgUrl() {
      return this.$store.state.config.bookObj.currentBgUrl
    },
    currentBgImg() {
      return this.$store.state.config.bookObj.currentBgImg
    },
    srcArr() {
      return this.bgType === 'epaperGroupBg'
        ? [
            { src: require('@/assets/imgs/paper/bg1.png') },
            { src: require('@/assets/imgs/paper/bg2.png') },
            { src: require('@/assets/imgs/paper/bg3.png') },
            { src: require('@/assets/imgs/paper/bg4.png') },
            { src: require('@/assets/imgs/paper/bg5.png') },
            { src: require('@/assets/imgs/paper/bg6.png') },
            { src: require('@/assets/imgs/paper/bg7.png') },
            { src: require('@/assets/imgs/paper/bg8.png') },
            { src: require('@/assets/imgs/paper/bg9.png') },
            { src: require('@/assets/imgs/paper/bg10.png') },
            { src: require('@/assets/imgs/paper/bg11.png') },
            { src: require('@/assets/imgs/paper/bg12.png') },
            { src: require('@/assets/imgs/paper/bg13.png') },
            { src: require('@/assets/imgs/paper/bg14.png') },
            { src: require('@/assets/imgs/paper/bg15.png') },
            { src: require('@/assets/imgs/paper/bg16.png') },
            { src: require('@/assets/imgs/paper/bg17.png') },
            { src: require('@/assets/imgs/paper/bg18.png') },
            { src: require('@/assets/imgs/paper/bg19.png') },
            { src: require('@/assets/imgs/paper/bg20.png') },
            { src: require('@/assets/imgs/paper/bg21.png') }
          ]
        : [
            { src: require('@/assets/imgs/bg7.png') },
            { src: require('@/assets/imgs/bg5.png') },
            { src: require('@/assets/imgs/bg12.png') },
            { src: require('@/assets/imgs/bg8.png') },
            { src: require('@/assets/imgs/bg9.png') },
            { src: require('@/assets/imgs/bg30.png') },
            { src: require('@/assets/imgs/bg10.png') },
            { src: require('@/assets/imgs/bg11.png') },
            { src: require('@/assets/imgs/bg14.png') },
            { src: require('@/assets/imgs/bg15.png') },
            { src: require('@/assets/imgs/bg33.png') },
            { src: require('@/assets/imgs/bg34.png') },
            { src: require('@/assets/imgs/bg35.png') },
            { src: require('@/assets/imgs/bg36.png') },
            { src: require('@/assets/imgs/bg37.png') },
            { src: require('@/assets/imgs/bg38.png') },
            { src: require('@/assets/imgs/bg22.png') },
            { src: require('@/assets/imgs/bg28.png') },
            { src: require('@/assets/imgs/bg2.png') },
            { src: require('@/assets/imgs/bg3.png') },
            { src: require('@/assets/imgs/bg4.png') },
            { src: require('@/assets/imgs/bg6.png') },
            { src: require('@/assets/imgs/bg13.png') },
            { src: require('@/assets/imgs/bg16.png') },
            { src: require('@/assets/imgs/bg17.png') },
            { src: require('@/assets/imgs/bg18.png') },
            { src: require('@/assets/imgs/bg19.png') },
            { src: require('@/assets/imgs/bg23.png') },
            { src: require('@/assets/imgs/bg24.png') },
            { src: require('@/assets/imgs/bg26.png') },
            { src: require('@/assets/imgs/bg31.png'), border: true },
            { src: require('@/assets/imgs/bg32.png') },
            { src: require('@/assets/imgs/bg39.png') },
            { src: require('@/assets/imgs/bg40.png') },
            { src: require('@/assets/imgs/bg41.png') },
            { src: require('@/assets/imgs/bg42.png') },
            { src: require('@/assets/imgs/bg43.png') },
            { src: require('@/assets/imgs/bg44.png') },
            { src: require('@/assets/imgs/bg45.png') },
            { src: require('@/assets/imgs/bg46.png') },
            { src: require('@/assets/imgs/bg47.png') },
            { src: require('@/assets/imgs/bg48.png') },
            { src: require('@/assets/imgs/bg49.png') },
            { src: require('@/assets/imgs/bg50.png') },
            { src: require('@/assets/imgs/bg51.png') },
            { src: require('@/assets/imgs/bg52.png') },
            { src: require('@/assets/imgs/bg53.png') },
            { src: require('@/assets/imgs/bg54.png') },
            { src: require('@/assets/imgs/bg55.png') }
          ]
    }
  },
  watch: {
    type() {
      this.selectIndex = null
    },
    currentBgUrl(val) {
      if (val && val != '') {
        this.selectCurrentBgUrl()
      }
    }
  },
  methods: {
    changeBg(data, index) {
      this.selectIndex = index
      this.$store.commit('config/UPDATE_CURRENT_BG', data)
      if (data.includes('img/bg')) {
        this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'template')
      } else {
        this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'custom')
      }
    },
    async uploadImg(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.fileName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let params = new FormData()
      params.append('fieldName', this.bgType)
      params.append(this.bgType, file)
      editApi.uploadPicture(params).then(async (res) => {
        if (res.status === 200 && res.data.code === 0) {
          await _this.getImage()
          _this.uploadBg = true
          if (_this.privateSrc.length > 0) {
            _this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'custom')
            _this.$store.commit('config/UPDATE_CURRENT_BG', _this.privateSrc[0].path)
            _this.selectIndex = 0
          }
        } else {
          // alert(res.data.msg)
        }
      })
    },
    buttonHandler(e) {
      if (e === '0') {
        this.getVipInfo()
        const res = this.compare({ key: 'customBg', type: 'boole' })
        if (!res) {
          this.$refs.memberDialog.visible = true
        } else {
          this.type = '1'
          this.getImage()
        }
      } else {
        this.type = '0'
      }
    },
    delBg(item) {
      this.delId = item.id
      this.$refs.deleteDialog.visible = true
    },
    async getImage() {
      await editApi.getImageList({ module: this.bgType }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.privateSrc = res.data.data
        } else {
          console.log('获取背景列表失败')
        }
      })
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
    },
    deleteConfrim() {
      editApi.delImage({ ids: this.delId }).then(async (res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.selectIndex = null
          await this.getImage()
          this.setSelect()
        } else {
          console.log('删除背景列表失败')
        }
      })
      this.delId = ''
      this.$refs.deleteDialog.visible = false
    },
    setSelect() {
      for (let i = 0; i < this.privateSrc.length; i++) {
        if (this.privateSrc[i].path === this.currentBgUrl) {
          this.type = '1'
          setTimeout(() => {
            this.selectIndex = i
          })
          break
        }
      }
    },
    selectCurrentBgUrl() {
      if (this.currentBgImg === 'template') {
        for (let i = 0; i < this.srcArr.length; i++) {
          if (this.srcArr[i].src === this.currentBgUrl) {
            this.type = '0'
            setTimeout(() => {
              this.selectIndex = i
            })
            break
          }
        }
      } else {
        this.getVipInfo()
        const res = this.compare({ key: 'customBg', type: 'boole' })
        if (res) {
          this.setSelect()
        }
      }
    }
  },
  mounted() {},
  created() {
    this.getImage()
  },
  components: {
    TipDialog
  }
}
</script>
<style lang="scss">
.edit-bg {
  text-align: center;
  height: 100%;
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  img {
    width: 160px;
    height: 80px;
    margin-top: 10px;
    cursor: pointer;
  }
  .bgTitle {
    width: 100%;
    text-align: center;
    line-height: 13px;
    font-size: 14px;
    margin-top: 20px;
    .title-radio {
      .el-radio__input {
        display: none;
      }
    }
  }
  .uploadBg {
    margin-bottom: 10px;
    text-align: center;
    .customBg {
      width: 160px;
      margin: 0 auto;
      display: -webkit-flex;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 0;
    }
    .uploadBgButton {
      width: 100px;
      height: 24px;
      background: #df5813;
      color: #fff;
      border-radius: 15px;
      font-size: 14px;
      display: flex;
      display: inline-flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      // margin: 10px 0;
      // margin-left: 30px;
      cursor: pointer;
    }
    .thumbnail {
      width: 160px;
      height: 80px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto;
      p {
        width: 100%;
        // height: 40px;
        text-align: center;
        font-size: 14px;
        margin: 0;
        line-height: 20px;
      }
      img {
        margin-top: 0;
        cursor: pointer;
      }
    }
    .upload-tip {
      height: 50px;
      background-color: #fffaf4;
      color: #515151;
    }
  }
  .selected {
    border: 1px solid #df5813;
  }
  .selected-icon {
    width: 13px;
    height: 13px;
    background: #df5813;
    color: #ffffff;
    display: block;
    position: absolute;
    right: 70px;
    top: 10px;
    line-height: 13px;
  }
  .bg-img {
    position: relative;
    .border {
      border: 1px solid #000;
    }
    &:hover .deal-btn-wrapper {
      display: block;
    }
  }
  .deal-btn-wrapper {
    width: 160px;
    height: 30px;
    display: none;
    position: absolute;
    bottom: 7px;
    right: 70px;
    background: rgba(0, 0, 0, 0.5);
    img.icon-style {
      width: 20px;
      height: 20px;
    }
  }
}
.default-edit_bg {
  height: 150px;
  .el-scrollbar {
    text-align: left;
    overflow-y: hidden;
    .bgTitle {
      text-align: left;
      position: absolute;
      top: 0;
      width: 220px;
      .el-radio {
        color: #3a3a3a;
      }
    }
    .public-bg {
      margin-top: 40px;
      display: flex;
      flex-direction: row;
      height: 100px;
      width: 100%;
    }
    .uploadBg {
      display: flex;
      flex-direction: row;
      position: relative;
      height: 100px;
      width: 100%;
      margin-top: 40px;
      .upload-tip {
        height: 80px;
        background-color: #fffaf4;
        p {
          font-size: 12px;
        }
        .customBg {
          height: 20px;
        }
      }
      .thumbnail {
        margin: auto 10px auto 0;
      }
    }
    .bg-img {
      margin: 0 10px 0 0;
      .selected-icon {
        right: 0;
      }
      .deal-btn-wrapper {
        right: 0;
      }
    }
    .el-scrollbar__view {
      width: fit-content;
    }
  }
}
</style>
